module.exports = __webpack_public_path__ + "static/media/menu.00b27c6b.svg";